import { render } from "./HomeSection2Cmp.vue?vue&type=template&id=32a9ef3c"
import script from "./HomeSection2Cmp.vue?vue&type=script&lang=js"
export * from "./HomeSection2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__